<div class="filter-group" data-group-visibility-id="showIdentifiedItemsHighlights">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showIdentifiedItemsHighlights" (click)="filter.groupVisibility.showIdentifiedItemsHighlights = !filter.groupVisibility.showIdentifiedItemsHighlights; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="{{ filter.groupVisibility.showIdentifiedItemsHighlights ? 'Identified Item Categories' : 'Identified Items' }}" [activeRules]="activeRules.identifiedItemFilters">
          <app-mod-tier-explainer [filter]="filter" [quickFiltersVersion]="true"></app-mod-tier-explainer>
        </span>
      </span>
    </div>
  </div>

  @if (navigationEnabled || filter.groupVisibility.showIdentifiedItemsHighlights) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showIdentifiedItemsHighlights">

      @if (poe2) {
        <div class="filter filter-property full-span" [class.disabled]="!filter.showAllIdentifiedItems">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showAllIdentifiedItems" (click)="toggleShowAllIdentifiedItems()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Show All Identified Items" ruleId="identified-item-show-all" [additionalContent]="showAllIdentifiedItemsTooltip">
              Always show all identified items dropped on the ground. Fine for most players. Reduces Filter Output size, which might slightly increase performance.
              <br /><br />Disable this if you regularly identify items and then throw them on the ground to only keep potentially good ones. Greatly increases Filter Output size, which might slightly reduce performance.
            </span>
            <ng-template #showAllIdentifiedItemsTooltip>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherAllIdentifiedItems"
                [active]="filter.showAllIdentifiedItems"
                exampleName="Identified Item"
                rareName="Dread Knot"
                [rarity]="Rarity.Rare"></app-equipment-tier-picker>
            </ng-template>
          </span>
        </div>
      }

      <div [class.disabled-filter-property-container]="filter.showAllIdentifiedItems">

        @if (filter.showAllIdentifiedItems) {
          <div class="disabled-filter-property" (click)="navigateToShowAllIdentifiedItems()">
            Disabled by <strong>Show All Identified Items</strong> setting.
          </div>
        }

        <div class="filter filter-property full-span" [class.disabled]="!filter.showIdentifiedGear || filter.showAllIdentifiedItems">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showIdentifiedGear" [disabled]="filter.showAllIdentifiedItems" (click)="toggleHighlightIdentifiedGear()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Identified Gear" [additionalContent]="selectedExcellentIdentifiedGearStylePreview" ruleId="gear-identified-excellent">
              <ng-template #selectedExcellentIdentifiedGearStylePreview>
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherExcellentIdentifiedGear"
                  [active]="filter.showIdentifiedGear"
                  rareName="Dread Bane"
                  [exampleName]="filter.showIdentifiedAttackWeaponTypes[0] == 'All' ? 'Excellent Example Gear' : filter.showIdentifiedAttackWeaponTypes[0]"
                  [rarity]="Rarity.Rare"></app-equipment-tier-picker>
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherGoodIdentifiedGear"
                  [active]="filter.showIdentifiedGear"
                  rareName="Dread Bane"
                  [exampleName]="filter.showIdentifiedAttackWeaponTypes[0] == 'All' ? 'Good Example Gear' : filter.showIdentifiedAttackWeaponTypes[0]"
                  [rarity]="Rarity.Rare"></app-equipment-tier-picker>
              </ng-template>
            </span>
            <span class="sep"></span>
            <button class="btn toggle-button show-filters-button" [class.active]="showIdentifiedGearFilters" [disabled]="!filter.showIdentifiedGear"
              (click)="showIdentifiedGearFilters = !showIdentifiedGearFilters">
              <span class="icon icon-equalizer"></span>
            </button>
          </span>
        </div>

        @if (showIdentifiedGearFilters) {
          <div class="filter filter-property filter-padded-left" style="width: 100%;">
            <span class="filter-body">
              <span filter-title text="{{ isMobile() ? 'Attack Weapon' : 'Attack Weapon Category' }}" ruleId="gear-identified-excellent"></span>
              <span class="sep"></span>
              <app-autocomplete
                [options]="identifiedAttackWeaponCategories"
                [disabled]="!filter.showIdentifiedGear"
                [showOptions]="true"
                [selectedValues]="filter.showIdentifiedAttackWeaponCategories || ['All']"
                (selectedValuesChange)="highlightIdentifiedAttackWeaponCategoriesChanged($event)"
              ></app-autocomplete>
              <span class="sep"></span>
              <div class="filter-title filter-label">
                Class
              </div>
              <span class="sep"></span>
              <app-autocomplete
                [options]="identifiedAttackWeaponClasses"
                [disabled]="!filter.showIdentifiedGear"
                [showOptions]="true"
                [selectedValues]="filter.showIdentifiedAttackWeaponTypes || ['All']"
                (selectedValuesChange)="highlightIdentifiedAttackWeaponTypesChanged($event)"
              ></app-autocomplete>
            </span>
          </div>
          <div class="filter filter-property filter-padded-left" style="width: 100%;">
            <span class="filter-body">
              <span filter-title text="{{ isMobile() ? 'Caster Weapon' : 'Caster Weapon Category' }}" ruleId="gear-identified-excellent"></span>
              <span class="sep"></span>
              <app-autocomplete
                [options]="identifiedCasterWeaponCategories"
                [disabled]="!filter.showIdentifiedGear"
                [showOptions]="true"
                [selectedValues]="filter.showIdentifiedCasterWeaponCategories || ['All']"
                (selectedValuesChange)="highlightIdentifiedCasterWeaponCategoriesChanged($event)"
              ></app-autocomplete>
            </span>
          </div>
          @if (poe1) {
            <div class="filter filter-property filter-padded-left" style="width: 100%;">
              <span class="filter-body">
                <span filter-title text="{{ isMobile() ? 'Gem Weapon' : 'Gem Weapon Category' }}" ruleId="gear-identified-excellent"></span>
                <span class="sep"></span>
                <app-autocomplete
                  [options]="identifiedGemWeaponCategories"
                  [disabled]="!filter.showIdentifiedGear"
                  [showOptions]="true"
                  [selectedValues]="filter.showIdentifiedGemWeaponCategories || ['All']"
                  (selectedValuesChange)="highlightIdentifiedGemWeaponCategoriesChanged($event)"
                ></app-autocomplete>
              </span>
            </div>
          }
          <div class="filter filter-property filter-padded-left" style="width: 100%;">
            <span class="filter-body">
              <span filter-title text="{{ isMobile() ? 'Quiver' : 'Quiver Category' }}" ruleId="gear-identified-excellent"></span>
              <span class="sep"></span>
              <app-autocomplete
                [options]="identifiedQuiversCategories"
                [disabled]="!filter.showIdentifiedGear"
                [showOptions]="true"
                [selectedValues]="filter.showIdentifiedQuiverCategories || ['All']"
                (selectedValuesChange)="highlightIdentifiedQuiverCategoriesChanged($event)"
              ></app-autocomplete>
            </span>
          </div>
          <div class="filter filter-property filter-padded-left" style="width: 100%;">
            <span class="filter-body">
              <span filter-title text="{{ isMobile() ? 'Life Armour' : 'Life Armour Category' }}" ruleId="gear-identified-excellent"></span>
              <span class="sep"></span>
              <app-autocomplete
                [options]="identifiedLifeArmourCategories"
                [disabled]="!filter.showIdentifiedGear"
                [showOptions]="true"
                [selectedValues]="filter.showIdentifiedLifeArmourCategories || ['All']"
                (selectedValuesChange)="highlightIdentifiedLifeArmourCategoriesChanged($event)"
              ></app-autocomplete>
              <span class="sep"></span>
              <div class="filter-title filter-label">
                Defence Type
              </div>
              <span class="sep"></span>
              <app-autocomplete
                [allLabel]="'All'"
                [options]="defenceTypes"
                [disabled]="!filter.showIdentifiedGear"
                [showOptions]="true"
                [selectedValues]="filter.showIdentifiedLifeArmourTypesDefenceTypes || ['All']"
                (selectedValuesChange)="highlightIdentifiedLifeArmourTypesDefenceTypesChanged($event);"></app-autocomplete>
              </span>
          </div>
          <div class="filter filter-property filter-padded-left" style="width: 100%;">
            <span class="filter-body">
              <span filter-title text="{{ isMobile() ? 'ES Armour' : 'ES Armour Category' }}" ruleId="gear-identified-excellent"></span>
              <span class="sep"></span>
              <app-autocomplete
                [options]="identifiedEnergyShieldArmourCategories"
                [disabled]="!filter.showIdentifiedGear"
                [showOptions]="true"
                [selectedValues]="filter.showIdentifiedEnergyShieldArmourCategories || ['All']"
                (selectedValuesChange)="highlightIdentifiedEnergyShieldArmourCategoriesChanged($event)"
              ></app-autocomplete>
              <span class="sep"></span>
              <div class="filter-title filter-label">
                Defence Type
              </div>
              <span class="sep"></span>
              <app-autocomplete
                [allLabel]="'All'"
                [options]="defenceTypes"
                [disabled]="!filter.showIdentifiedGear"
                [showOptions]="true"
                [selectedValues]="filter.showIdentifiedEnergyShieldArmourTypesDefenceTypes || ['All']"
                (selectedValuesChange)="highlightIdentifiedEnergyShieldArmourTypesDefenceTypesChanged($event);"></app-autocomplete>
              </span>
          </div>
        }

        <div class="filter filter-property full-span" [class.disabled]="!filter.showIdentifiedJewellery || filter.showAllIdentifiedItems">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showIdentifiedJewellery" [disabled]="filter.showAllIdentifiedItems" (click)="toggleHighlightIdentifiedJewellery()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Identified Jewellery" [additionalContent]="selectedExcellentIdentifiedJewelleryStylePreview" ruleId="jewellery-identified-excellent">
              <ng-template #selectedExcellentIdentifiedJewelleryStylePreview>
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherExcellentIdentifiedJewellery"
                  [active]="filter.showIdentifiedJewellery"
                  rareName="Dread Knot"
                  exampleName="Excellent Amulet"
                  [rarity]="Rarity.Rare"></app-equipment-tier-picker>
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherGoodIdentifiedJewellery"
                  [active]="filter.showIdentifiedJewellery"
                  rareName="Dread Knot"
                  exampleName="Good Amulet"
                  [rarity]="Rarity.Rare"></app-equipment-tier-picker>
              </ng-template>
            </span>
            <span class="sep"></span>
            <button class="btn toggle-button show-filters-button" [class.active]="showIdentifiedJewelleryFilters" [disabled]="!filter.showIdentifiedJewellery"
              (click)="showIdentifiedJewelleryFilters = !showIdentifiedJewelleryFilters">
              <span class="icon icon-equalizer"></span>
            </button>
          </span>
        </div>

        @if (showIdentifiedJewelleryFilters) {
          <div class="filter filter-property filter-padded-left" style="width: 100%;">
            <span class="filter-body">
              <span filter-title text="{{ isMobile() ? 'Category' : 'Jewellery Category' }}" ruleId="jewellery-identified-excellent"></span>
              <span class="sep"></span>
              <app-autocomplete
                [options]="identifiedJewelleryCategories"
                [disabled]="!filter.showIdentifiedJewellery"
                [showOptions]="true"
                [selectedValues]="filter.showIdentifiedJewelleryCategories || ['All']"
                (selectedValuesChange)="highlightIdentifiedJewelleryCategoriesChanged($event)"
              ></app-autocomplete>
            </span>
          </div>
        }

        <div class="filter filter-property full-span" [class.disabled]="!filter.showIdentifiedJewels || filter.showAllIdentifiedItems">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showIdentifiedJewels" [disabled]="filter.showAllIdentifiedItems" (click)="toggleHighlightIdentifiedJewels()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Identified Jewels" [additionalContent]="selectedExcellentIdentifiedJewelsStylePreview" ruleId="jewels-identified-excellent">
              <app-content cid="excellent-jewels" contentType="tip"></app-content>
              <ng-template #selectedExcellentIdentifiedJewelsStylePreview>
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherExcellentIdentifiedJewels"
                  [active]="filter.showIdentifiedJewels"
                  rareName="Dread Bane"
                  [exampleName]="poe1 ? 'Excellent Murderous Eye Jewel' : 'Excellent Jewel'"
                  [rarity]="Rarity.Rare"></app-equipment-tier-picker>
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherGoodIdentifiedJewels"
                  [active]="filter.showIdentifiedJewels"
                  rareName="Dread Bane"
                  [exampleName]="poe1 ? 'Good Murderous Eye Jewel' : 'Good Jewel'"
                  [rarity]="Rarity.Rare"></app-equipment-tier-picker>
              </ng-template>
            </span>
            <span class="sep"></span>
            <button class="btn toggle-button show-filters-button" [class.active]="showIdentifiedJewelsFilters" [disabled]="!filter.showIdentifiedJewels"
              (click)="showIdentifiedJewelsFilters = !showIdentifiedJewelsFilters">
              <span class="icon icon-equalizer"></span>
            </button>
          </span>
        </div>

        @if (showIdentifiedJewelsFilters) {
          <div class="filter filter-property filter-padded-left" style="width: 100%;">
            <span class="filter-body">
              <span filter-title text="{{ isMobile() ? 'Jewels' : 'Jewel Category' }}" ruleId="jewels-identified-excellent"></span>
              <span class="sep"></span>
              <app-autocomplete
                [options]="identifiedJewelCategories"
                [disabled]="!filter.showIdentifiedJewels"
                [showOptions]="true"
                [selectedValues]="filter.showIdentifiedJewelCategories || ['All']"
                (selectedValuesChange)="highlightIdentifiedJewelCategoriesChanged($event)"
              ></app-autocomplete>
            </span>
          </div>

          @if (poe1) {
            <div class="filter filter-property filter-padded-left" style="width: 100%;">
              <span class="filter-body">
                <span filter-title text="{{ isMobile() ? 'Abyss Jewels' : 'Abyss Jewel Category' }}" ruleId="jewels-identified-excellent"></span>
                <span class="sep"></span>
                <app-autocomplete
                  [options]="identifiedAbyssJewelCategories"
                  [disabled]="!filter.showIdentifiedJewels"
                  [showOptions]="true"
                  [selectedValues]="filter.showIdentifiedAbyssJewelCategories || ['All']"
                  (selectedValuesChange)="highlightIdentifiedAbyssJewelCategoriesChanged($event)"
                ></app-autocomplete>
              </span>
            </div>
          } @else if (poe2) {
            <div class="filter filter-property filter-padded-left" style="width: 100%;">
              <span class="filter-body">
                <span filter-title text="{{ isMobile() ? 'Time-Lost Jewels' : 'Time-Lost Jewel Category' }}" ruleId="jewels-identified-excellent"></span>
                <span class="sep"></span>
                <app-autocomplete
                  [options]="identifiedTimeLostJewelCategories"
                  [disabled]="!filter.showIdentifiedJewels"
                  [showOptions]="true"
                  [selectedValues]="filter.showIdentifiedTimeLostJewelCategories || ['All']"
                  (selectedValuesChange)="highlightIdentifiedTimeLostJewelCategoriesChanged($event)"
                ></app-autocomplete>
              </span>
            </div>
          }
        }

        <div class="filter filter-property full-span" [class.disabled]="!filter.showIdentifiedCustomItems || filter.showAllIdentifiedItems">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showIdentifiedCustomItems" [disabled]="filter.showAllIdentifiedItems" (click)="toggleHighlightIdentifiedCustomItems()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Identified Custom Items" [additionalContent]="selectedExcellentIdentifiedCustomItemsStylePreview" ruleId="gear-identified-custom-excellent">
              On the <a href="/tier-list/mods">Mod Tier List</a> tab, you can create your own Item Categories with the sets of mods you're looking for.
              <ng-template #selectedExcellentIdentifiedCustomItemsStylePreview>
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherExcellentIdentifiedCustomItems"
                  [active]="filter.showIdentifiedCustomItems"
                  rareName="Dread Bane"
                  exampleName="Excellent Item"
                  [rarity]="Rarity.Rare"></app-equipment-tier-picker>
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherGoodIdentifiedCustomItems"
                  [active]="filter.showIdentifiedCustomItems"
                  rareName="Dread Bane"
                  exampleName="Good Item"
                  [rarity]="Rarity.Rare"></app-equipment-tier-picker>
              </ng-template>
            </span>
          </span>
        </div>

        @if (poe1) {
          <div class="filter filter-property full-span" [class.disabled]="!filter.showRestrictedModIdentifiedItems">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!filter.showRestrictedModIdentifiedItems" (click)="toggleHighlightRestrictedModIdentifiedItems()"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Restricted Mod Items" [additionalContent]="selectedRestrictedModIdentifiedItemsStylePreview" ruleId="gear-restricted-mod">
                <ng-template #selectedRestrictedModIdentifiedItemsStylePreview>
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherIdentifiedRestrictedModItems"
                    [active]="filter.showRestrictedModIdentifiedItems"
                    rareName="Dread Bane"
                    [exampleName]="'Amulet'"
                    [rarity]="Rarity.Rare"></app-equipment-tier-picker>
                </ng-template>
              </span>
              <span class="sep"></span>
              <app-select-gear-tier [greaterThanOrEqualTo]="true" [disabled]="!filter.showRestrictedModIdentifiedItems"
                [(ngModel)]="filter.showRestrictedModIdentifiedItemsGearTier" (selectedValueChange)="updateFilter();"></app-select-gear-tier>
              <span class="sep"></span>
              <button class="btn toggle-button show-filters-button" [class.active]="showRestrictedModIdentifiedItemsFilters" [disabled]="!filter.showRestrictedModIdentifiedItems"
                (click)="showRestrictedModIdentifiedItemsFilters = !showRestrictedModIdentifiedItemsFilters">
                <span class="icon icon-equalizer"></span>
              </button>
            </span>
          </div>

          @if (showRestrictedModIdentifiedItemsFilters) {
            <div class="filter filter-property filter-padded-left" style="width: 100%;">
              <span class="filter-body">
                <span filter-title text="Types"></span>
                <span class="sep"></span>
                <app-filter-checkbox-group
                  [filter]="filter"
                  filterPropertyName="showRestrictedModIdentifiedItemsDelve"
                  labelText="Delve"
                  [disabledWhen]="!filter.showRestrictedModIdentifiedItems"></app-filter-checkbox-group>
                <span class="sep"></span>
                <app-filter-checkbox-group
                  [filter]="filter"
                  filterPropertyName="showRestrictedModIdentifiedItemsIncursion"
                  labelText="Incursion"
                  [disabledWhen]="!filter.showRestrictedModIdentifiedItems"></app-filter-checkbox-group>
                <span class="sep"></span>
                <app-filter-checkbox-group
                  [filter]="filter"
                  filterPropertyName="showRestrictedModIdentifiedItemsBreach"
                  labelText="Breach"
                  [disabledWhen]="!filter.showRestrictedModIdentifiedItems"></app-filter-checkbox-group>
              </span>
            </div>
            <div class="filter filter-property filter-padded-left" style="width: 100%;">
              <span class="filter-body">
                <span filter-title text="{{ isMobile() ? 'Weapon' : 'Weapon Classes' }}"></span>
                <span class="sep"></span>
                <app-autocomplete
                  [options]="identifiedAttackWeaponClasses"
                  [disabled]="!filter.showRestrictedModIdentifiedItems"
                  [showOptions]="true"
                  [selectedValues]="filter.showRestrictedModIdentifiedItemsWeaponTypes || ['All']"
                  (selectedValuesChange)="highlightRestrictedModIdentifiedItemsWeaponTypesChanged($event)"
                ></app-autocomplete>
                <span class="sep"></span>
                <div class="filter-title filter-label">
                  Defence Types
                </div>
                <span class="sep"></span>
                <app-autocomplete
                  [options]="defenceTypes"
                  [disabled]="!filter.showRestrictedModIdentifiedItems"
                  [showOptions]="true"
                  [selectedValues]="filter.showRestrictedModIdentifiedItemsDefenceTypes || ['All']"
                  (selectedValuesChange)="highlightRestrictedModIdentifiedItemsDefenceTypesChanged($event)"
                ></app-autocomplete>
              </span>
            </div>
          }
        }

        <div class="filter filter-property full-span" [class.disabled]="!filter.hideRemainingIdentifiedItems || filter.showAllIdentifiedItems">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.hideRemainingIdentifiedItems" [disabled]="filter.showAllIdentifiedItems" (click)="toggleHideRemainingIdentifiedItems()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Hide All other non-Unique Identified Equipment" ruleId="equipment-hide-remaining-identified">
              Hide any identified Equipment (Gear and Jewellery, no Waystones or other special items not covered by the Identified Items rules) which don't meet any of the selected Identified Item Categories & Configurations.
              <br /><br />This is especially useful if you identify items in your inventory and throw them on the ground to only keep potentially good ones.
              <br /><br />If this rule is disabled, all remaining identified items will be shown.
            </span>
            <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              filterPropertyName="hideRemainingIdentifiedItemsIncludingCorrupted"
              labelText="Including Corrupted"
              [disabledWhen]="!filter.hideRemainingIdentifiedItems || filter.showAllIdentifiedItems"></app-filter-checkbox-group>
          </span>
        </div>
      </div>
    </div>
    <div class="clear"></div>
  }
</div>

@if (navigationEnabled || filter.groupVisibility.showIdentifiedItemsHighlights) {
  <div class="filter-group" data-group-visibility-id="showIdentifiedItemsHighlights" [class.collapsed]="!filter.groupVisibility.showIdentifiedItemsHighlights">
    <div class="filter-group-header">
      <div class="filter">
        <span class="input-group-btn">
          <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showIdentifiedItemConfigurations" (click)="filter.groupVisibility.showIdentifiedItemConfigurations = !filter.groupVisibility.showIdentifiedItemConfigurations; updateFilter()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Identified Item Configurations" [activeRules]="activeSpecialRules.identifiedItemConfigs">
            <!-- Note: this also appears on the mod tier explainer component -->
            When specifying a Mod Tier requirement for a Configuration, that always means 'This Mod Tier or better'. Specifying a minimum number of Great+ mods means 'at least this many Great or Perfect' mods, and specifying a minimum number of Good+ mods means 'at least this many Good, Great or Perfect' mods.

            <br /><br />All conditions must apply. Let's take the 'Excellent Rare Equipment' Configuration as an example: minimum 1 Great+ Prefix, minimum 1 Great+ Suffix, minimum 4 Good+ mods, and maximum 0 Bad mods. This means: in total at least 4 Good, Great or Perfect mods, of which one must be a Great or Perfect Prefix, and one must be a Great or Perfect Suffix. Additionally, no Bad mods are allowed.
          </span>
        </span>
      </div>
    </div>

    @if (navigationEnabled || filter.groupVisibility.showIdentifiedItemConfigurations) {
      <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showIdentifiedItemConfigurations">

        <div [class.disabled-filter-property-container]="filter.showAllIdentifiedItems">
          @if (filter.showAllIdentifiedItems) {
            <div class="disabled-filter-property" (click)="navigateToShowAllIdentifiedItems()">
              Disabled by <strong>Show All Identified Items</strong> setting.
            </div>
          }

          @for (identifiedItemConfig of filter.identifiedItemConfigs; track $index) {
            <app-identified-item-configuration
              [identifiedItemConfig]="identifiedItemConfig"
              [index]="$index"
              (remove)="removeIdentifiedItemConfiguration($event)">
            </app-identified-item-configuration>
          }

          <div class="filter filter-padded">
            <button type="button" class="btn clear-btn" style="width: 100%;" (click)="addIdentifiedItemConfiguration()">
              Add Identified Item Configuration
            </button>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    }
  </div>
}
